import {ISxMap} from "@ui/leafletCustom/leafletContainer/types";

export const sxMap: ISxMap = {
    map: {
        borderRadius: '8px',
        position:'relative'
    },
    search: {
        width: '300px'
    }


}